import React from 'react'
import NextLink from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import { CERTIFICATE_HELP_ZENDESK_LINK } from 'app/ProfileRevampPage/constants'
import { useSETrackEventCertificates } from 'app/ProfileRevampPage/hooks/useSETrackEventCertificates'

const CertificateEndResult = () => {
  const { SETrackCertificateList } = useSETrackEventCertificates()
  return (
    <div className="relative flex items-end justify-between bg-surface-informational-subdued">
      <div className="w-full relative p-4 pr-0 z-10 before:absolute before:content-[''] before:bg-[url('/illustrations/img-empty-document.png')] before:bg-contain before:bg-no-repeat before:right-0 before:-bottom-0 before:w-[104px] before:h-[88px]">
        <Text variant="action" className="mb-4">
          Ada sertifikat yang tidak muncul di sini?
        </Text>
        <NextLink href={CERTIFICATE_HELP_ZENDESK_LINK} passHref>
          <Button
            as="a"
            target="_blank"
            color="white"
            className="!bg-transparent mb-6 max-w-fit"
            size="sm"
            variant="solid"
            onClick={() => {
              SETrackCertificateList('PELAJARI_LEBIH_LANJUT')
            }}
          >
            Pelajari lebih lanjut
          </Button>
        </NextLink>
      </div>
    </div>
  )
}

export default CertificateEndResult
